import cookie from 'js-cookie'
import { canUseDOM, updateCartCounter } from '@common/utils'
import { constants } from '@common/services'

const isProd = process.env.NODE_ENV === 'production'
const authTokenOverride = false

const getCookieNameFromKey = key => {
  return `${constants.COOKIE_NAMESPACE}__${key}`
}

// 1 / 48 = 30 minutes
const set = (key, input, expires = 1 / 48, domain) => {
  if (input !== undefined && input !== null) {
    cookie.set(getCookieNameFromKey(key), input, {
      expires,
      domain
    })
  }
  return input
}

const get = (key, domain) => {
  try {
    const data = cookie.get(getCookieNameFromKey(key), {
      domain
    })
    return data || ''
  } catch (e) {
    return ''
  }
}

const remove = key => {
  try {
    cookie.remove(getCookieNameFromKey(key))
    return true
  } catch (e) {}
  return false
}

const setToken = token =>
  token && authTokenOverride && set(constants.JWT_TOKEN, token)
const setSpiceId = id => id && set(constants.SPICE_ID, id, 365)
const setProfileName = name => name && set(constants.PROFILE_NAME, name, 365)
const setQureToken = token => token && set(constants.QURE_TOKEN, token)
const setUserId = id => id && set(constants.USER_ID, id, 30)
const setUpgradeFlowFlag = value =>
  value && set(constants.UPGRADE_FLOW_FLAG, value, 1 / 24 / 60 / 2) // 1 / 24 / 60 / 2 = 30 seconds
const setFamilyWarning = value =>
  value && set(constants.FAMILY_WARNING, value, 1)

const removeToken = () => {
  authTokenOverride
    ? remove(constants.JWT_TOKEN)
    : set(constants.JWT_TOKEN, '', new Date(0), constants.COOKIE_DOMAIN)
}

const unsetAuthData = () => {
  updateCartCounter(0)
  try {
    remove(constants.SPICE_ID)
    remove(constants.PROFILE_NAME)
    removeTDCampaigns()
    return true
  } catch (e) {
    console.log(e)
  }
}
const getToken = () => get(constants.JWT_TOKEN)
const getSpiceId = () => get(constants.SPICE_ID)
const getProfileName = () => get(constants.PROFILE_NAME)
const getQureToken = () => get(constants.QURE_TOKEN)
const getUserId = () => get(constants.USER_ID)
const getUpgradeFlowFlag = () => get(constants.UPGRADE_FLOW_FLAG)
const getFamilyWarning = () => get(constants.FAMILY_WARNING)
const getReactOverwriteRouteRegister = () =>
  get(constants.COOKIE_REACT_OVERWRITE_ROUTE_REGISTER)

const tokenize = (path, req) => {
  const token = canUseDOM ? getToken() : req ? req.query.token : undefined

  if (token && token !== 'null' && token !== 'undefined') {
    return `${path}${path.indexOf('?') !== -1 ? '&' : '?'}token=${token}`
  }
  return path
}

const qureTokenize = (path, req) => {
  const token = canUseDOM ? getQureToken() : req ? req.query.token : undefined

  if (token && token !== 'null' && token !== 'undefined') {
    return `${path}${path.indexOf('?') !== -1 ? '&' : '?'}token=${token}`
  }
  return path
}

const tokenHeader = () => {
  const token = getToken()
  if (token && token !== 'null') {
    return {
      Authorization: `Bearer ${token}`
    }
  }
  return {}
}

const authorizationTokenHeader = (req, isQureToken) => {
  const token = canUseDOM
    ? isQureToken
      ? getQureToken()
      : getToken()
    : req
    ? req.query.token
    : undefined
  if (token && token !== 'null' && token !== 'undefined') {
    return {
      Authorization: `Bearer ${token}`
    }
  }
  return {}
}

const setTDCampaigns = (key, value) => {
  if (key && value !== undefined && value !== null) {
    cookie.set(`${constants.X_SEGMENT}_${key}`, value, {
      expires: isProd ? 1 / 6 : 1 // 4h || 1d
    })
  }
}

const removeTDCampaigns = () => {
  Object.keys(cookie.get()).forEach(c => {
    if (c.startsWith(constants.X_SEGMENT)) {
      cookie.remove(c)
    }
  })
}

export default {
  get,
  set,
  remove,
  getToken,
  setToken,
  removeToken,
  unsetAuthData,
  tokenize,
  tokenHeader,
  authorizationTokenHeader,
  setSpiceId,
  getSpiceId,
  getQureToken,
  setQureToken,
  getUserId,
  setUserId,
  qureTokenize,
  setUpgradeFlowFlag,
  getUpgradeFlowFlag,
  getFamilyWarning,
  setFamilyWarning,
  setTDCampaigns,
  setProfileName,
  getProfileName,
  getReactOverwriteRouteRegister
}
